export default {"src":"/_next/static/media/dmiLogo.15f1a28f.svg","height":51,"width":197};